import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            全网热议的影视话题，看看大家都在聊什么
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic, idx) => (
              <a
                key={idx}
                href={`#${topic.name}`}
                className="group inline-flex items-center gap-3 px-5 py-3 rounded-full bg-background-50 border border-background-200 hover:border-primary-300 hover:shadow-sm transition-all duration-200 cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 bg-background-200/70 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {topic.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}